var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4839 1.6129H23.0645M14.4839 7.74194H23.0645M1 13.871H23.0645M1 20H23.0645M8.96774 6.43032V2.92452C8.96774 1.55161 8.41613 1 7.03097 1H3.53742C2.16452 1 1.6129 1.55161 1.6129 2.92452V6.41806C1.6129 7.80323 2.16452 8.35484 3.53742 8.35484H7.03097C8.41613 8.35484 8.96774 7.80323 8.96774 6.43032Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburger-icon.4e98932bb2352d933b4eedf54f1426cd.svg";
export { ForwardRef as ReactComponent };